<template>
  <div 
    :class="{'colorized': isColorized, 'has-image': hasImage }" 
    class="ec-answer ec-radio" 
    @click.stop="toggle">
    <span 
      v-show="effectedWarningEnabled" 
      :aria-label="$t('answers.change_warning_msg')"
      class="ec-answer-effected-warning-edge hint--bottom-left hint--medium">
      <i 
        class="fa fa-exclamation" 
        aria-hidden="true" />
    </span>
    <div class="ec-answer-main">
      <div 
        class="ec-answer-text" 
        v-html="answer.answer"/>
      <div class="ec-answer-input">
        <template v-if="!overrideByContactForm">
          <div class="pretty p-default p-round">
            <input 
              :id="answer.id+'-true'"
              :name="answer.id+'-radio-btn'"
              :value="true"
              :checked="radioStatus"
              :disabled="disabled"
              type="checkbox">
            <div class="state p-primary">
              <label :for="answer.id+'-true'">{{ $t('general.yes') }}</label>
            </div>
          </div>
          <div class="pretty p-default p-round">
            <input 
              :id="answer.id+'-false'"
              :name="answer.id+'-radio-btn'"
              :value="false"
              :checked="!radioStatus"
              :disabled="disabled"
              type="checkbox">
            <div class="state p-primary">
              <label :for="answer.id+'-false'">{{ $t('general.no') }}</label>
            </div>
          </div>   
        </template>
        <div class="ec-answer-input-overlay" v-if="overrideByContactForm">
          <a href="#" @click.stop="callContactModal" class="btn is-blue" style="min-width:150px" v-text="$t('general.contact_btn')" />
        </div>
      </div>
    </div>
    <div 
      v-if="hasImage" 
      class="ec-answer-image" 
      @click="showImage">
      <div class="ec-answer-img-wrapper">
        <div class="ec-answer-img-overlay">
          <div class="ec-img-overlay-icon"><i 
            aria-hidden="true" 
            class="fa fa-search"/></div>
        </div> 
        <img :src="imageSrc" >
      </div>
    </div>
    <AnswerDebug 
      v-if="answer.additional_informations" 
      :debug-info="answer.additional_informations"
    />
  </div>
</template>
<script>
    import { isNull } from 'lodash'
    import Answer from './Answer.vue'

    export default {
        name: "RadioAnswer",
        extends: Answer,
        data:function() {
          return {
              radioStatus: (this.answer.value === this.answer.value_true) ? true : false
          }
        },
        computed: {
          isYes() {
              if(this.value === this.answer.value_true) {
                  return true
              }

              return false
          },
          isColorized() {
              if(this.overrideByContactForm) {
                return false
              }

              if(isNull(this.forceHighlighted)) {
                  if(this.isSingleAnswer) {
                      if(this.isYes && this.isValid) {
                          return true
                      }
                  } else {
                      return this.isSelectedAnswer && this.isYes && this.isValid
                  }

                  return false
              }

              return this.forceHighlighted                
          },
          disabled() {
              return this.$store.readOnly
          }
        },
        watch: {
          radioStatus: {
              handler: function(newState) {
                  if(newState) {
                      this.value = this.answer.value_true
                  } else {
                      this.value = this.answer.value_false
                  }
              },
              immediate: true
          }
        },
        methods: {
          toggle(event) {
              if(this.overrideByContactForm) {
                return
              }

              if(this.effectedWarningEnabled && !isNull(event)) {
                  this.goingToChangeValue()
                  event.preventDefault(event)
                  return
              }

              if(!this.disabled) {
                  this.radioStatus = !this.radioStatus
              }
          },
          initRadioStatus() {
              return (this.answer.value === this.answer.value_true) ? true : false
          }
        },
    }
</script>